import { Children, isValidElement, ReactNode } from 'react';

import { Field } from '../Field';
import type { FieldOverrideProps } from '../Field.types';
import type { InfoField } from '../Fields.types';

export interface FieldOverride {
	renderValue?: (field: InfoField) => ReactNode;
}

/** Extracts an id→override map from an Info type's children, ignoring anything that isn't a
 * `Field` element. Duplicate ids: last one wins (children are iterated in order). */
export const collectFieldOverrides = <Id extends string = string>(children: ReactNode): Map<Id, FieldOverride> => {
	const overrides = new Map<Id, FieldOverride>();
	Children.forEach(children, (child) => {
		if (isValidElement(child) && child.type === Field) {
			const { id, renderValue } = child.props as FieldOverrideProps<Id>;
			overrides.set(id, { renderValue });
		}
	});
	return overrides;
};
